<template>
  <div>
    <div id="rates" class="d-flex flex-column justify-content-top align-items-left" v-if='ratesLg'>
        <div id="header" class="d-flex flex-row justify-content-end align-items-center">
            <div class="col1">
                <div class="title">{{ ratesLg.lg1.settings.rates_extratitle }}</div>
                <div class="subtitle">{{ ratesLg.lg1.settings.subtitle }}</div>
            </div>
            <div class="col2">
                <div v-html="ratesLg.lg1.periodTitle.period1"></div>
            </div>
            <div class="col3">
                <div v-html="ratesLg.lg1.periodTitle.period2"></div>
            </div>
        </div>
        <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
            <row class="rowa" v-for="(rates, index) in ratesLg.lg1.rates" :key="index" :ratesLg1='rates' :ratesLg2='ratesLg.lg2.rates2[index]'></row>
        </div>
        <legalNoticeLeft :legalNoticeLg="legalNoticeLg"></legalNoticeLeft>
    </div>
  </div>
</template>

<script>
import Row from './rowRates'
import LegalNoticeLeft from './legalNoticeLeft'

export default {
  components: {
    row: Row,
    'legalNoticeLeft': LegalNoticeLeft
  },
  name: 'IbisStylesRatesHorizontalV1Rates',
  props: {
    ratesLg: Object
  },
  computed: {
    legalNoticeLg () {
      return {lg1: this.ratesLg.lg1.subtitles['1'], lg2: this.ratesLg.lg2.subtitles['1']}
    },
    lg1 () {
      return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
    },
    lg2 () {
      return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibisstyles.scss";

#rates {
  width: 100%;
  height: 100%;
  @include marginPercent(45, 0, 0, 0);

  #header {
    width: 100%;
    @include heightPercent(80);
    text-align: right;
    font-family: 'Gotham-Bold';
    @include fontSize(25);
    text-transform: uppercase;
    border-bottom: 2px solid black;

    .col1 {
        text-align: left;

        .title {
            @include fontSize(25);
            color: black;
        }

        .subtitle {
            @include fontSize(23);
            color: #6AB023;
        }
    }
  }

  .col1 {
    @include widthPercent(509);
    @include marginPercent(0, 20, 0, 0);
  }

  .col2 {
    @include widthPercent(210);
    @include marginPercent(0, 10, 0, 0);
  }

  .col3 {
    @include widthPercent(210);
    @include marginPercent(0, 10, 0, 0);
  }

  #rows {
    width: 100%;

    .rowa:nth-of-type(n+7){
      display:none!important;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/rates/rates.vue